<template>
    <div>        
        <md-list>
            <md-list-item 
                v-for="block in featuredWorkflowBlocks" 
                :key="block.title"
                :md-ripple="false"
                v-on:dblclick="loadFeaturedBlock(block.id, block.title)"
                @click="viewFeaturedWorkflow(block)"
                >
                <md-button class="md-button md-list-action" 
                @focus="viewFeaturedWorkflow(block)"
                @click="viewFeaturedWorkflow(block)"
                :title="`Load the ` + block.title +` workflow`">
                    <span class="md-list-item-text">{{block.title}}</span>
                </md-button>
                <md-button
                class="md-button md-dense"
                @click.stop="loadFeaturedBlock(block.id, block.title)" title="Load workflow">
                    Load
                    <md-icon>open_in_browser</md-icon>
                </md-button>
                <!-- <md-button
                    class="md-raised md-accent md-dense" 
                    @click.stop="loadFeaturedBlock(block.id, block.title)" 
                    title="Load workflow">
                    Load Workflow
                </md-button> -->
            </md-list-item>
        </md-list>
    </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import { AnalyticsService } from "@/services/analytics.service";
import { GA_EVENTS } from "@/constants/gaConstants.js";

export default {
    name: 'FeaturedBlocks',
    props: {
        featuredWorkflowBlocks: {
            type: Array,
            required: true
        }
    },
    data: () => ({
        selectedBlock: -1,
        showLoadButton: null
    }),
    methods: {
        viewFeaturedWorkflow(block) {
            this.$emit("view-featured-workflow", block);
            this.showLoadButton = block.title;
        },
        loadFeaturedBlock(id, title) {
            AnalyticsService.logAnalyticsEvent(GA_EVENTS.LOAD_EXAMPLE_WORKFLOW, null, {'title': title });
            this.$emit("featured-block", id);
            this.showLoadButton = null;
        },
    }
}
</script>

<style scoped lang="scss">
.md-list {
    .md-list-item {
        border-bottom: 1px solid #d0d0d0;
        &:first-of-type {
            border-top: 1px solid #d0d0d0;
        }
    }
    .md-button.md-list-action{
        height: auto;
        
    }
}

.md-list-item-text {
    white-space: normal;
    text-align: left;
}
.md-icon.md-theme-default.md-icon-font {
    color: rgba(0, 0, 0, 0.64);    
}
.md-button.md-theme-default[disabled] .md-icon-font {
    color: rgba(0, 0, 0, 0.32);
}
</style>